import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {OptionService} from '../../../Services/option.service';
import {Option} from '../../../Models/Option';
import {LanguageModel} from '../../../../translation/translation.models';
import {LanguageService} from '../../../../translation/Services/language.service';
import {TranslationFormlyService} from '../../../Services/translation.formly.service';
import {FabricCollectionService} from '../../../Services/fabric-collection.service';
import {FabricCollection} from '../../../Models/FabricCollection';
import {OrderDownlineTreeviewEventParser, TreeviewConfig, TreeviewEventParser, TreeviewItem} from '@paymate-software/ngx-treeview';
import {ProductTreeviewConfig} from '../../supplier/view-supplier/view-supplier.component';
import {Model} from '../../../Models/Model';
import {CollectionService} from '../../../Services/collection.service';
import {ProductService} from '../../../Services/product.service';
import {Property} from '../../../Models/Property';
import * as _ from 'lodash';
import { Grid } from 'src/app/shared/Models/grid';
import { createPartsModalGridConfig } from '../../product/view-product/configs';
import { PartsService } from 'src/app/back-office/Services/parts.service';
import { PartTableEvent } from 'src/app/shared/Models/PartsTable';
import { PartOption } from 'src/app/back-office/Models/Part';

@Component({
  selector: 'app-view-option',
  templateUrl: './view-option.component.html',
  styleUrls: ['./view-option.component.scss'],
  providers: [
    {provide: TreeviewEventParser, useClass: OrderDownlineTreeviewEventParser},
    {provide: TreeviewConfig, useClass: ProductTreeviewConfig}
  ]
})
export class ViewOptionComponent implements OnInit {

  public option: Option = new Option();
  public newOption: Option = new Option();
  public options: Option[] = [];
  public parents: Option[] = [];
  public optionId: number;
  public optionIdRemove: number;
  public editId: number;
  public optionName: string;
  public attachedFabrics: number;
  public languages: LanguageModel[] = [];
  private optionTranslationFields = ['name'];
  public languageMap = {};
  public isEdit = false;
  public fabricCollections: FabricCollection[] = [];
  public fabricCollectionsForOptions = [];
  public selectedFabrics = [];
  public fabrics = [];
  public properties: Property[] = [];
  public childItem = [];
  public items = [];
  public selectedProducts = [];
  public activeModels = [];
  public archive = false;
  public uniqueActiveModels = [];
  public isLoading = false;
  public optionHasPart = false;
  public showPartModal = false;
  public partsGrid: Grid;
  public removeSelectedPart: number[] = [];
  public selectedPartsTemp: PartOption[] = [];
  public selectedParts: PartOption[] = [];
  
  config = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: false,
    maxHeight: 400
  });
  @ViewChild('deleteModal', {static: false}) deleteModal = null;
  @ViewChild('optionModal', {static: false}) optionModal = null;
  @ViewChild('addNewOption', {static: false}) addNewOption = null;
  @ViewChild('reAddModal', {static: false}) reAddModal = null;
  @ViewChild('partsModal', {static: false}) partsModal = null;
  @ViewChild('partRowDetail', {static: false}) partRowDetail: TemplateRef<any>;


  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly optionService: OptionService,
    private readonly productService: ProductService,
    private readonly languageService: LanguageService,
    private readonly fabricCollectionService: FabricCollectionService,
    private readonly collectionService: CollectionService,
    private readonly partsService: PartsService,
  ) {}

  ngOnInit() {
    // this.route.root.children[0].snapshot.data.title='fsdfsdfsdfsd'
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.optionId = params['id'];
        this.getBaseOption();
        this.languageService.list().subscribe(langResp => {
          this.languages = langResp.languages;
          this.languages.forEach(lang => {
            this.languageMap[lang.locale] = lang.locale;
          });
        });
        this.loadFabricsForOptions();
        this.optionService.getPriceMultiplier().subscribe((response) => {
          this.properties = response.data;
        });
        this.isLoading = true;
        this.collectionService.getProductOptions().subscribe((res) => {
          res.data.forEach((collection) => {
            const children = [];
            collection.models.forEach((model: Model) => {
              const styles = [];
              if (model.styles.length > 0) {
                model.styles.forEach((modelStyle) => {
                  const products = [];
                  model.products.forEach((product) => {
                    let checkItem = product.optionProducts.find(x => (!x.deleted && x.option.id == this.optionId && x.style && x.style.id == modelStyle.id));
                    if (checkItem) {
                      checkItem = (model.optionProducts.findIndex(x => (x.option.id == checkItem.option.id)) !== -1);
                    } else {
                      checkItem = false;
                    }
                    products.push({
                      text: product.name || "", value: product.id, checked: checkItem
                    });
                    if (checkItem) {
                      this.selectedProducts.push(product.id);
                    }
                  });
                  if (products.length > 0) {
                    styles.push({
                      text: modelStyle.name || "", value: modelStyle.id, children: products
                    });
                  }
                });
                if (styles.length > 0) {
                  children.push({
                    text: model.name || "", value: model.id, collapsed: true, children: styles
                  });
                }
              } else {
                const products = [];
                model.products.forEach((product) => {
                  let checkItem = product.optionProducts.find(x => (!x.deleted && x.option.id == this.optionId));
                  if (checkItem) {
                    checkItem = (model.optionProducts.findIndex(x => (!x.deleted && x.option.id == checkItem.option.id)) !== -1);
                  } else {
                    checkItem = false;
                  }
                  products.push({
                    text: product.name || "", value: product.id, checked: checkItem
                  });
                  if (checkItem) {
                    this.selectedProducts.push(product.id);
                  }
                });
                if (products.length > 0) {
                  children.push({
                    text: model.name || "", value: model.id, collapsed: true, children: products
                  });
                }
              }
            });
            if (children.length > 0) {
              const collectionItem = new TreeviewItem({text: collection.name || "", value: collection.id, collapsed: true, children: children});
              this.childItem.push(collectionItem);
            }
          });
          this.isLoading = false;
        });
        this.items = this.childItem;
      }
    });
  }

  loadFabricsForOptions() {
    this.fabricCollectionService.getFabricCollectionListOption().subscribe((resp) => {
      const fabricCollections = resp.data;
      fabricCollections.map((fabricCollection) => {
        this.fabricCollectionsForOptions.push({
          id: fabricCollection.id,
          title: fabricCollection.name,
        });
      });
    });
  }

  getValues(array) {
    const result = [];
    array.forEach(function iterate(path: any) {
      return function (o) {
        const temp = new Option();
        result.push(o);
        if (o.options) {
          o.options.forEach(iterate(temp));
          return;
        }
      };
    }([]));
    return result;
  }

  setDetailForSoftDelete(id, name) {
    this.deleteModal.show();
    this.editId = id;
    this.optionName = name.bold();
  }

  softDelete() {
    this.deleteFabricFromCollection();
  }

  deleteFabricFromCollection() {
    this.optionService.softDeleteOption(this.editId).subscribe((res) => {
      this.deleteModal.hide();
      this.getBaseOption();
    });
  }

  changeFabricsForOptions(event) {
    const fabricCollections = [];
    event.forEach((fabricCollection) => {
      fabricCollections.push(fabricCollection.id);
    });
    this.newOption.fabricCollections = fabricCollections;
  }

  getOption() {
    return Option;
  }

  calculate(index) {
    let dot = ' - ';
    if (typeof index === 'string') {
      const array = index.split('.');
      for (let i = 1; i < array.length; i++) {
        dot += ' - ';
      }
    }
    return dot;
  }

  addOption() {
    this.newOption = new Option();
    this.newOption.translations = TranslationFormlyService.prepareTranslationFields(this.optionTranslationFields,
      this.newOption.translations, this.languages);
    this.newOption.translationKeys = TranslationFormlyService.findTranslationKeys(this.newOption);
    this.newOption.translationEntries = TranslationFormlyService.findTranslationEntries(this.newOption);
    this.isEdit = false;
    this.optionModal.show();
  }

  manageOption(option: Option) {
    this.prepareNewOption(option);
    this.optionModal.show();
  }

  prepareNewOption(option: Option) {
    this.newOption = new Option();
    this.newOption = JSON.parse(JSON.stringify(option));
    this.newOption.parent = this.newOption?.parent ? Number(this.newOption.parent) : null;
    this.newOption.fabricCollection = (this.newOption.fabricCollection) ? this.newOption.fabricCollection['id'] : null;
    this.newOption.priceMultiplier = (this.newOption.priceMultiplier) ? this.newOption.priceMultiplier['id'] : null;
    this.newOption.translations = TranslationFormlyService.prepareTranslationFields(this.optionTranslationFields,
      this.newOption.translations, this.languages);
    this.newOption.translationKeys = TranslationFormlyService.findTranslationKeys(this.newOption);
    this.newOption.translationEntries = TranslationFormlyService.findTranslationEntries(this.newOption);
    this.isEdit = true;
    this.selectedFabrics = [];
    this.newOption.fabricCollections.map((fabricCollection) => {
      this.selectedFabrics.push(fabricCollection.id);
    });
    this.changeFabricsForOptions(this.newOption.fabricCollections);
    this.removeSelectedPart = this.newOption.partOptions?.map(part => part.part.id);
    this.optionHasPart = this.newOption.partOptions?.length > 0;
  }

  submitOption() {
    const option = JSON.parse(JSON.stringify(this.newOption));
    option.translations = TranslationFormlyService.reorganizeTranslations(this.optionTranslationFields, this.newOption.translations);
    delete option.translationKeys;
    delete option.translationEntries;
    delete option.position;
    delete option.parentPosition;
    delete option.products;
    delete option.id;
    delete option.systemDescription;
    delete option.name;
    delete option.options;
    delete option.fabrics;
    delete option.fabricColors;
    delete option.fabricCollection;
    delete option.optionProducts;
    delete option.deleted;
    delete option.description;
    delete option.partOptions;
    option.status = true;
    if (this.optionHasPart) {
      option.parts = this.newOption.partOptions?.map(part => ({id: part.part.id, amount: part.amount}));
    } else {
      option.parts = [];
    }
    this.optionService.manageSubOption({option: option}, this.isEdit, (this.isEdit) ? this.newOption.id : null).subscribe((res) => {
      this.optionModal.hide();
      this.getBaseOption();
    this.addNewOption.reset();
    });
  }

  getBaseOption() {
    let uniqueModels = [];
    this.optionService.getOptionItem(this.optionId).subscribe((resp) => {
      this.option = resp;
      this.activeModels = resp.optionProducts;
      this.activeModels.forEach(item => {
        if (!item.deleted) {
          uniqueModels.push(item.model);
        }
      });

      this.uniqueActiveModels = _.unionBy(uniqueModels, 'id');
      this.prepareActiveModelsName();
      this.options = resp.options;
      this.parents = this.getValues(this.options);
      this.parents.unshift(this.option);
      this.attachedFabrics = this.options.length;
    });
  }

  onSelectedChange(items) {
    this.selectedProducts = [];
    items.forEach(downlineItem => {
      const product = downlineItem.item;
      const productvalue = product.value;
      const parentItem = downlineItem.parent.parent.parent;
      let styleValue;
      let modelValue;
      if (parentItem !== null) {
        styleValue = downlineItem.parent.item.value;
        modelValue = downlineItem.parent.parent.item.value;
      } else {
        styleValue = null;
        modelValue = downlineItem.parent.item.value;
      }
      if (!product.disabled) {
        this.selectedProducts.push({product: productvalue, style: styleValue, model: modelValue});
      }
    });
  }
  onFilterChange($event) {
  }

  setProducts(next: boolean) {
    if (next) {
      this.productService.setOptions({optionProducts: this.selectedProducts}, this.optionId).subscribe((res) => {
        this.router.navigateByUrl('/back-office/option/overview');
      });
    } else {
       this.router.navigateByUrl('/back-office/option/overview');
    }
  }

  positionChange(id, positionNumber) {
    const position = {position: positionNumber};
    this.optionService.setParentPosition(position, id).subscribe(
      (res) => {
        this.getBaseOption();
      });
  }

  prepareActiveModelsName() {
    const models = [];
    this.activeModels.forEach((modelItem) => {
      models.push(modelItem.model);
    });

    // this.activeModels = models.reduce((acc, current) => {
    //   const x = acc.find(item => item.id === current.id);
    //   return (!x === true) ? acc.concat([current]) : acc;
    // }, []);
  }

  loadArchivedOptions() {
    this.optionService.getDeletedOptionsOfAnOption(this.optionId).subscribe(resp => {
      this.options = resp;
      this.archive = true;
    });
  }

  loadOptions() {
    this.optionService.getOptionItem(this.optionId).subscribe((resp) => {
      this.options = resp.options;
      this.archive = false;
    });
  }

  showReAddForSubOption(optionId, optionName) {
    this.optionIdRemove = optionId;
    this.optionName = optionName;
    this.reAddModal.show();
  }

  reAddSubOption() {
    this.optionService.readdOption(this.optionIdRemove).subscribe((resp) => {
      this.reAddModal.hide();
      this.loadArchivedOptions();
    });
  }

  parentSelected(event, parent) {
    // const parentChosen = parent.find(x => x.id === event);
    // this.newOption.customerPrice = parentChosen.customerPrice;
    // this.newOption.dealerPrice = parentChosen.dealerPrice;
  }

  get checkDisability() {
    return this.addNewOption ? !this.addNewOption.valid : false;
  }

  addPart(event: PartOption[]) {
    this.selectedPartsTemp = event;
  }

  cancelPartModel() {
    this.selectedPartsTemp = [];
    this.partsModal.hide();
    this.showPartModal = false;
  }

  updateOptionParts() {
    this.optionService.getOptionItem(this.optionId).subscribe((resp) => {
      this.newOption = resp.options.find(option => option.id === this.newOption.id);
      this.prepareNewOption(this.newOption);
    });
  }

  addToPart() {
    this.partsModal.hide();
    this.showPartModal = false;
    this.selectedParts = this.selectedPartsTemp;
    const newPartOptions = this.selectedPartsTemp.map(part => ({
      id: this.newOption.id,
      amount: 1, 
      part: part, 
      option: String(this.newOption.id), 
    }));
    this.newOption.partOptions = [...(this.newOption.partOptions ?? []), ...newPartOptions] as PartOption[];
    this.removeSelectedPart = this.newOption.partOptions?.map(part => part.part.id);
    this.optionHasPart = this.newOption.partOptions?.length > 0;
  }

  showPartGrid() {
    this.partsModal.show();
    this.showPartModal = true;
    this.partsGrid = createPartsModalGridConfig(
      this.router,
      this.partsService,
      this.partRowDetail,
      this.removeSelectedPart
    );
  }

  updatePartAmount(event: PartTableEvent) {
    this.newOption.partOptions[event.index].amount = event.amount;
  }

  onHasPartOptionChange(event: Event) {
    if (!(event.target as HTMLInputElement).checked && this.newOption.partOptions?.length > 0) {
      this.optionHasPart = false;
    } else {
      this.optionHasPart = true;
    }
  }

  removePart(event: PartTableEvent) {
    this.newOption.partOptions.splice(event.index, 1);
    this.removeSelectedPart = this.newOption.partOptions.map(part => part.part.id);
    this.optionHasPart = this.newOption.partOptions.length > 0;
  }
}
